import styled from 'styled-components';
import TabComponent from '../TabComponent';
import { useEffect, useState } from 'react';
import useRudderStackAnalytics from '../../useRudderAnalytics';
import { useStake } from './query/staking';
import { toast } from 'react-toastify';
import { useQueryClient } from '@tanstack/react-query';
import { UNISWAP_SWAP_URL } from '../../utils/constants';
import { getUniswapQuoteForXtreme } from '../../utils/airdrop/uniswap';
import Loader from '../staking/Loader';


const LoaderContainer = styled.div<{ width: number }>`
  display: flex;
  align-items: center;
  justify-content: center;
  width: ${props => props.width}px;
  height: 20px;
`;

const ContainerDiv = styled.div`
  display: flex;
  width: 100%;
  height: 100%;
  justify-content: flex-start;
  `

const RightMidContainerDiv = styled.div`
  display: flex;
  justify-content: flex-end;
  width: 100%;
  @media (max-width: 768px) {
    flex-direction: column;
    align-items: flex-end;
    justify-content: space-between;
  } 
`;

const LeftDiv = styled.div`
  display: flex;
  flex-direction: column;
  padding-left: 15px;
  flex: none;
  height: 100%;
  justify-content: center;
  
`;

const MidDiv = styled.div`
  display: flex;
  height: 100%;
  justify-content: flex-start;
  margin-right: 60px;
  align-items: center;
  @media (max-width: 768px) {
    justify-content: center
    align-items: center;
    margin-right: 0;
  }
`;

const RightDiv = styled.div`
  display: flex;
  height: 100%;
  align-items: center;
`;

const BalanceTitleSpan = styled.span`
  font-family: BPdotsSquares;
  font-size: 13px;
  font-style: normal;
  font-weight: 700;
  line-height: 100%; /* 13px */
  letter-spacing: 3.38px;
  text-transform: uppercase;
  @media (max-width: 768px) {
    color: #00C2FF;
    font-family: BPdotsSquares;
    font-size: 11px;
    font-style: normal;
    font-weight: 700;
    line-height: 100%; /* 11px */
    letter-spacing: 2.86px;
    text-transform: uppercase;
  }
`;

const TotalXTremeSpan = styled.span`
  font-family: BPdotsUnicaseSquare;
  font-size: 26px;
  font-style: normal;
  font-weight: 700;
  line-height: 100%; /* 26px */
  text-transform: uppercase;
`;

const XtremeCountSpan = styled.span`
  font-family: BPdotsUnicaseSquare;
  font-size: 26px;
  font-style: normal;
  font-weight: 700;
  line-height: 100%; /* 26px */
  text-transform: uppercase;
  @media (max-width: 768px) {
    color: #00C2FF;
    font-family: BPdotsUnicaseSquare;
    font-size: 20px;
    font-style: normal;
    font-weight: 700;
    line-height: 100%; /* 20px */
    text-transform: uppercase;
  }
`;

const XNetPointSpan = styled.span`
  font-family: BPdotsUnicaseSquare;
  font-size: 16px;
  font-style: normal;
  font-weight: 700;
  line-height: 100%; /* 16px */
  letter-spacing: 1.28px;
  text-transform: uppercase;
  opacity: 0.4;
  margin-top: 4px;
  @media (max-width: 768px) {
    color: #00C2FF;
    font-family: BPdotsUnicaseSquare;
    font-size: 11px;
    font-style: normal;
    font-weight: 700;
    line-height: 100%; /* 11px */
    letter-spacing: 0.88px;
    text-transform: uppercase;
  }
`;

const FullyStakedSpan = styled.span`
  color: #00C2FF;
  font-family: BPdotsUnicaseSquare;
  font-size: 16px;
  font-style: normal;
  font-weight: 700;
  line-height: 100%; /* 16px */
  text-transform: uppercase;
  margin-bottom: 3px;
  @media (max-width: 768px) {
    color: #00C2FF;
    font-family: BPdotsUnicaseSquare;
    font-size: 11px;
    font-style: normal;
    font-weight: 700;
    line-height: 100%; /* 11px */
    text-transform: uppercase;
  }
`

const RightButtonTextSpan = styled.span`
  text-align: center;
  font-family: BPdotsSquares;
  font-size: 14px;
  font-style: normal;
  font-weight: 700;
  line-height: 100%; /* 14px */
  text-transform: uppercase;
`;

const STATES = {
  FULLY_STAKED: 'FULLY_STAKED',
  NO_BALANCE: 'NO_BALANCE',
  UNSTAKED_AND_BALANCE: 'UNSTAKED_AND_BALANCE',
}

function getState(dashboardData: any){
  let state = STATES.NO_BALANCE;
  let balance = dashboardData?.xnetBalance - dashboardData?.staking?.staked;
  // balance = 10;
  if(dashboardData?.staking?.staked >= 0 && balance > 0) {
    state = STATES.UNSTAKED_AND_BALANCE;
  }
  else if(dashboardData?.staking?.staked > 0 && balance === 0) {
    state = STATES.FULLY_STAKED;
  }
  else if(dashboardData?.staking?.staked === 0 && balance === 0) {
    state = STATES.NO_BALANCE;
  }
  else {
    state = STATES.NO_BALANCE;
  }
  return state;
}

export default function BottomStakingComponent({ appState, dashboardData, isLoading, isMobile, refetch, xnetBalance }: any) {
  
  const [loading, setLoading] = useState(false);
  const [dollarValueXtreme, setDollarValueXtreme] = useState<number>(-1);
  const state = getState(dashboardData);
  let rtext = 'buy xtreme';
  let background =  '#021219';
  let textCol = '#00C2FF';
  let rBackground = '#00C2FF';
  let rColor = '#021219';
  if(state === STATES.UNSTAKED_AND_BALANCE) {
    rtext = 'stake now';
    background = '#00C2FF';
    textCol = '#021219';
    rBackground = '#021219';
    rColor = '#00C2FF';
  }
  const [analytics, setAnalytics] = useState(null);
  const queryClient = useQueryClient();

  useEffect(() => {
    setAnalytics(useRudderStackAnalytics());
  }, []);

  
  const { mutate: stakingMutation } = useStake({
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['dashboard'] });
      setLoading(false);
      toast.success('TRANSACTION SUCCESFUL');
      refetch();
      analytics?.track('STAKE SUCCESSFUL', {
        quantity: `${dashboardData?.xnetBalance - dashboardData?.staking?.staked}`,
        type: 'SOFT STAKE',
      });
      var audio = new Audio('/assets/music/Sfx_Xnet_Success.wav');
      // var audio = new Audio('/assets/music/Sfx_Xnet_Tokens.wav');
      audio.play();
    },
    onError: () => {
      setLoading(false);
      toast.success('TRANSACTION FAILED');
      // var audio = new Audio('/assets/music/Sfx_Xnet_Success.wav');
      var audio = new Audio('/assets/music/Sfx_XNET_UI_error.wav');
      // var audio = new Audio('/assets/music/Sfx_Xnet_Tokens.wav');
      audio.play();
    },
    amount: dashboardData?.xnetBalance - dashboardData?.staking?.staked,
  });

  const doStake = () => {
    let balance = dashboardData?.xnetBalance - dashboardData?.staking?.staked;
    if (balance > 0) {
      setLoading(true);
      stakingMutation();
    }
  };

  const rightButtonClick = ()=>{
    if(state == STATES.FULLY_STAKED) {
      window.open(UNISWAP_SWAP_URL, '_blank')
      return;
    }
    else if(state == STATES.UNSTAKED_AND_BALANCE){
      setLoading(true);
      doStake();
    }
    else{
      window.open(UNISWAP_SWAP_URL, '_blank')
    }
  }

  const fetchAndSetUSDPrice = async () => {
    let usdPrice = await getUniswapQuoteForXtreme();
    // multiply by dashboardData?.xnetBalance
    setDollarValueXtreme(usdPrice * dashboardData?.xnetBalance);
  }


  useEffect(()=>{
    if(dashboardData?.xnetBalance && dashboardData?.xnetBalance>0){
      fetchAndSetUSDPrice()
    }
    else{
      setDollarValueXtreme(0);
    }
  },[xnetBalance]);

  return (
    <div style={{
      width: '100%',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
    }}>
      <TabComponent
        width={"576px"} height={"112px"}
        mobileHeight={'82px'} mobileWidth={'100%'}
        background={`${background};`}
        style={{ 
          paddingLeft: isMobile?5:15, 
          paddingRight: isMobile?3:10 }}
        parentStyle={{ position: 'relative',
           zIndex: 1,
           width: isMobile?'100%':'fit-content',
          }}
          noCut={isMobile?true:false}
      >
        <ContainerDiv style={{color:textCol}}>
            <LeftDiv>
              <div style={{display:"flex"}}>
                <BalanceTitleSpan>
                  $xtreme balance
                </BalanceTitleSpan>
              </div>
              <div style={{display:"flex", flexDirection:"column"}}>
                <XtremeCountSpan>
                  {dashboardData?.xnetBalance? dashboardData?.xnetBalance : 0} xtreme
                </XtremeCountSpan>
                {dollarValueXtreme == -1 && (
                    <LoaderContainer width={20}>
                      <Loader
                        style={{
                          opacity: 0.4,
                          marginTop: 10,
                          borderColor: '#00C2FF',
                          borderLeftColor: 'black',
                          visibility: 'visible'
                        }}
                      />
                    </LoaderContainer>
                  )}
                <XNetPointSpan>
                  {dollarValueXtreme != -1 && (<>${dollarValueXtreme.toFixed(2)}</>)}
                </XNetPointSpan>
              </div>
            </LeftDiv>
            <RightMidContainerDiv>
            {state == STATES.FULLY_STAKED && (
              <MidDiv>
              <TabComponent
                width={"138px"} height={"24px"}
                mobileHeight={'16px'} mobileWidth={'97px'}
                background={'#013456;'}
                >
                <FullyStakedSpan>
                  Fully Staked
                </FullyStakedSpan>
              </TabComponent>
            </MidDiv>
            )}
            <RightDiv>
          <TabComponent
                width={"131px"} height={"39px"}
                mobileHeight={'43px'} mobileWidth={'149px'}
                background={`${rBackground};`}
                parentStyle={{ 
                  marginRight: isMobile?0:20, 
                  cursor: 'pointer',
                }}
                onClick={rightButtonClick}
              >
                <RightButtonTextSpan style={{color:rColor}}>
                {loading ? 'PROCESSING' : rtext}
                </RightButtonTextSpan>
              </TabComponent>
          </RightDiv>
          </RightMidContainerDiv>
          
        </ContainerDiv>
      </TabComponent>
    </div>
  );
}